<template>
  <v-container fluid style="padding: 0; min-height: 100vh">
    <v-row no-gutters>
      <v-col cols="12">
        <GlobalNav></GlobalNav>
      </v-col>
      <v-col cols="12">
        <div class="d-flex h-100">
          <SideBar></SideBar>
          <div class="pa-5 w-100">
            <BreadCrumb :linksData="linksData" class="mb-5" />
            <div>
              <div
                class="leads-managements-link d-flex align-center ga-2 my-3 py-3"
              >
                <div
                  @click="$router.push({ name: 'EngagementAndInsights' })"
                  class="link cursor-pointer hoverd-style-line d-flex align-center ga-2"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.825 13L13.425 18.6L12 20L4 12L12 4L13.425 5.4L7.825 11H20V13H7.825Z"
                      fill="#1F666A"
                    />
                  </svg>
                  <span>Insights</span>
                </div>
              </div>
              <v-row>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="8">
                      <div class="post">
                        <div class="d-flex flex-wrap align-center ga-3 data">
                          <div
                            class="element d-flex align-center ga-2"
                            style="
                              box-shadow: rgba(222, 222, 222, 0.5) 0px 7.37px
                                44.24px 0px;
                            "
                          >
                            <span class="title">Platform :</span
                            ><span
                              v-if="post.platform"
                              class="value text-capitalize"
                              >{{ post.platform }}</span
                            >
                            <span v-else>no data</span>
                          </div>
                          <div
                            class="element d-flex align-center ga-2"
                            style="
                              box-shadow: rgba(222, 222, 222, 0.5) 0px 7.37px
                                44.24px 0px;
                            "
                          >
                            <span class="title">Date of publish :</span
                            ><span class="value" v-if="post.publish_date">
                              {{ post.publish_date.split(" ")[0] }}
                            </span>
                            <span class="value" v-else>No date</span>
                          </div>
                        </div>
                      </div>
                      <div class="post w-100 mt-5">
                        <div
                          class="element d-flex flex-column ga-3 pa-4"
                          style="
                            height: auto;
                            box-shadow: rgba(222, 222, 222, 0.5) 0px 7.37px
                              44.24px 0px;
                          "
                        >
                          <div
                            class="d-flex justify-space-between align-center title"
                          >
                            <span>Caption</span>
                            <span></span>
                          </div>
                          <div class="value">
                            <div class="contant-social-post-default mb-4">
                              <div
                                class="card positon-relative"
                                style="position: relative"
                              >
                                <!-- textarea  -->
                                <textarea
                                  placeholder="Write ....."
                                  name=""
                                  id=""
                                  rows="15"
                                  maxlength="2500"
                                  v-model="new_caption"
                                  ref="textarea"
                                ></textarea>
                                <div
                                  style="
                                    position: absolute;
                                    bottom: 12px;
                                    left: 0px;
                                    width: 100%;
                                  "
                                  class="textarea-actions d-flex align-center justify-space-between mt-3 px-3"
                                >
                                  <div
                                    class="btn-groups d-flex align-start ga-3"
                                  >
                                    <button
                                      class="btn-post"
                                      @click="toggleEmojiPicker"
                                    >
                                      <img
                                        src="@/assets/soft-ware-img/happy-face_8376596 1.svg"
                                        alt=""
                                      />
                                    </button>
                                  </div>
                                  <div class="word-length">
                                    <span> {{ longOfText }} </span> /
                                    <span>2500</span>
                                  </div>
                                </div>
                              </div>
                              <div
                                v-if="showEmojiPicker"
                                class="emoji-picker-wrapper"
                              >
                                <emoji-picker
                                  @emoji-click="onEmojiClick"
                                ></emoji-picker>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="d-flex align-center justify-end ga-3 mt-5">
                          <v-btn
                            variant="text"
                            @click="$router.back()"
                            class="cancel-btn"
                            >Cancel</v-btn
                          >
                          <v-btn
                            variant="text"
                            @click="UpdatePost"
                            class="save-btn"
                            >Save</v-btn
                          >
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="4">
                      <p style="font-weight: bold; margin-bottom: 1rem">
                        post image
                      </p>
                      <img
                        style="width: 90%; max-height: 30rem"
                        v-if="post.image"
                        :src="post.image"
                        alt="noimg"
                      />
                      <img
                        style="width: 90%"
                        v-else
                        src="@/assets/images/noimg.png"
                        alt="noimg"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BreadCrumb from "@/components/layout/BreadCrumb.vue";
import GlobalNav from "@/components/layout/GlobalNav.vue";
import SideBar from "@/components/layout/SideBar.vue";
import "emoji-picker-element";
import apiClient from "@/core/buildRequest";
import { useGeneralStore } from "@/store/General";
export default {
  name: "EngagementAndInsights",
  components: { BreadCrumb, GlobalNav, SideBar },
  data() {
    return {
      linksData: [
        { name: "Home", link: "/home-page" },
        { name: "Engagement and Insights", link: "" },
      ],
      new_caption: "",
      longOfText: 0,
      showEmojiPicker: false,
      post: {},
      general_store: useGeneralStore(),
    };
  },
  methods: {
    toggleEmojiPicker() {
      this.showEmojiPicker = !this.showEmojiPicker;
    },
    onEmojiClick(event) {
      const emoji = event.detail.unicode;
      const textarea = this.$refs.textarea;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;

      this.new_caption =
        this.new_caption.substring(0, start) +
        emoji +
        this.new_caption.substring(end);

      this.$nextTick(() => {
        textarea.selectionStart = textarea.selectionEnd = start + emoji.length;
        textarea.focus();
      });

      this.showEmojiPicker = false;
    },
    async getPost() {
      await apiClient
        .get(`/engagement-insights/get-post/${this.$route.params.id}`, {
          params: {
            platform: this.$route.params.id,
          },
        })
        .then((response) => {
          this.post = response.data.data;
          this.new_caption = this.post.post;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async UpdatePost() {
      if (this.new_caption.length === 0) {
        this.general_store.showSnackbar("Caption is required", "error");
        return;
      }

      this.general_store.ShowLoading();

      try {
        await apiClient.post(`/engagement-insights/update-post`, {
          platform: this.post.platform,
          post_id: this.post.id,
          message: this.new_caption,
        });
        this.general_store.showSnackbar("Post updated" , "#237276");
      } catch (error) {
        console.log(error);
        this.general_store.showSnackbar("Failed to update post", "error");
      } finally {
        this.general_store.HideLoading();
      }
    },
  },
  watch: {
    new_caption(val) {
      this.longOfText = val?.length;
    },
  },
  mounted() {
    this.general_store.ShowLoading();
    this.getPost().finally(() => {
      this.general_store.HideLoading();
    });
  },
};
</script>

<style scoped>
.post .element {
  height: 40px;
  padding: 0px 24px 0px 16px;
  background: #ffffff;
  border-radius: 8px;
}
.post .element .title {
  font-size: 14px;
  font-weight: 500;
  line-height: 16.94px;
  color: #0d0d0d;
}
.post .element .value {
  font-size: 16px;
  font-weight: 400;
  line-height: 19.36px;
  color: #666666;
}

.post .rectangle {
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0px 7.37px 44.24px 0px #dedede80;
  background: #ffffff;
  height: auto !important;
}
textarea {
  width: 100%;
  min-height: 394px;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #dadada;
  color: #666666;
}
textarea:focus-visible {
  outline: 1px solid #237276;
}
.cancel-btn {
  width: 100px;
  height: 32px;
  padding: 2px 8px 2px 8px;
  border-radius: 8px;
  background: #f2f2f2;
  color: rgb(99, 99, 99);
  text-align: center;
}
.cancel-btn:hover {
  background: #aaaaaa;
}
.save-btn {
  width: 100px;
  height: 32px;
  padding: 2px 8px 2px 8px;
  border-radius: 8px;
  background: #237276;
  color: white;
  text-align: center;
}
.save-btn:hover {
  background: #144244;
}
</style>
